import React from 'react';
import PropTypes from 'prop-types';

import { formatDate } from 'App/components/PatientProfile/PatientProfile.utils.js';
import env from 'App/components/config/config';
import ClinicalNoteDownload from 'App/components/ClinicalNoteDownload';
import { file as filePropType } from 'App/components/ClinicalNoteDownload/proptypes';
import { dateTimeSlashesFormat } from 'App/services/DateService';

const cdnURL = env.cdnURL || '';
const formatCreatedOn = (milliSec) => {
    try {
        return formatDate(milliSec, dateTimeSlashesFormat);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        return '';
    }
};
const propTypes = {
    file: filePropType.isRequired,
    selectedFiles: PropTypes.arrayOf(PropTypes.string).isRequired,
    toggleFileSelect: PropTypes.func.isRequired,
};

const defaultProps = {};

const FileRecord = ({ file, selectedFiles, toggleFileSelect }) => {
    const isFileSelected = selectedFiles.includes(file.id);
    return (
        <tr>
            <td>
                <img
                    className="patient-files-thumbnail"
                    src={`${cdnURL}/images/${file.icon}`}
                    alt={file.origFileName}
                />
            </td>
            <td>
                <ClinicalNoteDownload file={file} />

                <br />
                <span className="patient_files_created_on">{formatCreatedOn(file.createdOn)}</span>
            </td>
            <td className="text-right">
                <input
                    aria-label={`Select ${file.origFileName}`}
                    type="checkbox"
                    checked={isFileSelected}
                    onChange={(e) => toggleFileSelect(e, file.id)}
                />
            </td>
        </tr>
    );
};

FileRecord.propTypes = propTypes;
FileRecord.defaultProps = defaultProps;

export default React.memo(FileRecord);
